
import './Profile.css'

function SettingsProfile({ currentUser, userConfig }) {

    return (
        <div>

        </div>
    );
}


export default SettingsProfile;